// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_tt-8";
export var editMode = "_tt-3";
export var headerRow = "_tt-a";
export var headerTitle = "_tt-b";
export var product = "_tt-1";
export var productDetails = "_tt-5";
export var productDivider = "_tt-7";
export var productImage = "_tt-2";
export var productInfo = "_tt-4";
export var productTitle = "_tt-6";
export var strikethrough = "_tt-9";
export var upsellProductsCard = "_tt-0";